import { REDUX_ACTIONS } from "constants/constants";
import { cacheTheCart } from "utils/commonMethods";

//Format for items is {item: ITEM_OBJECT,quantity: ITEM_QUANTITY}
const initialState = {
  items: [],
  couponDetails: null,
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.ADD_ITEMS_TO_CART:
      cacheTheCart(action.payload);
      return { ...state, items: action.payload };
    case REDUX_ACTIONS.PUSH_COUPON_CODE_TO_CART:
      cacheTheCart(action.payload);
      return {
        ...state,
        couponDetails: action.payload,
      };
    case REDUX_ACTIONS.RESET_CART:
      cacheTheCart(initialState);
      return initialState;
    default:
      return state;
  }
};

export default cartReducer;
